<!-- Container -->
<div class="sel" [class.with-title]="!!cardTitle">

    <!-- Optional card header: makes the selector its own V2 card (no card-in-card nesting).
         Mirrors a primaryCardHeader mat-card-title + subtitle. -->
    <div class="sel-card-head" *ngIf="cardTitle">
        <div class="sel-card-title">{{ cardTitle }}</div>
        <div class="sel-card-subtitle" *ngIf="cardSubtitle">{{ cardSubtitle }}</div>
    </div>

    <!-- Toolbar (search input itself now lives on app-table below; this row scopes/filters it) -->
    <div class="toolbar">
        <button type="button"
                class="tb-btn"
                [class.has-badge]="selectedSearchFields.selected.length > 0"
                [matMenuTriggerFor]="searchByFieldMenu">
            <i class="ph-bold ph-funnel-simple icon-muted icon-16" aria-hidden="true"></i>
            Search by field
            <span class="badge">{{ selectedSearchFields.selected.length }}</span>
        </button>
        <mat-menu #searchByFieldMenu="matMenu" class="v2-panel" xPosition="before" [overlapTrigger]="false">
            <div *ngFor="let sf of searchFields; trackBy: trackBySearchField" mat-menu-item>
                <mat-checkbox [checked]="selectedSearchFields.isSelected(sf)"
                              (change)="selectedSearchFields.toggle(sf); getUnitList()"
                              (click)="$event.stopPropagation()">
                    <span class="select-column-label">{{ sf.label }}</span>
                </mat-checkbox>
            </div>
        </mat-menu>

        <button type="button"
                class="tb-btn"
                [class.active]="filterPanelOpen"
                [class.has-badge]="activeFilterCount > 0"
                (click)="toggleFilterPanel()">
            <i class="ph-bold ph-funnel icon-muted icon-16" aria-hidden="true"></i>
            Filters
            <span class="badge">{{ activeFilterCount }}</span>
        </button>

        <span class="sel-count">
            <b>{{ selection?.selected.length || 0 }}</b> of {{ totalRecords }} selected
        </span>
    </div>

    <!-- Filter panel -->
    <div class="filters" [class.open]="filterPanelOpen">
        <!-- Balance (multi-select dropdown, same pattern as tags) -->
        <div class="fg fg-narrow">
            <span class="fg-label">Balance</span>
            <div class="tag-wrap">
                <button type="button"
                        class="tag-trigger"
                        [class.has-sel]="balanceFilters.size > 0"
                        (click)="toggleBalanceDropdown(); $event.stopPropagation()">
                    {{ balanceFilters.size > 0 ? balanceFilters.size + ' active' : 'Any' }}
                </button>
                <div class="tag-dd" [class.open]="balanceDropdownOpen">
                    <div *ngFor="let opt of balanceOptions; trackBy: trackByBalanceOption"
                         class="tag-dd-item"
                         [class.state-has]="isBalanceFilterActive(opt.value)"
                         (click)="toggleBalanceFilter(opt.value); $event.stopPropagation()">
                        <div class="t-indicator"></div>
                        <span class="t-label">{{ opt.label }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Unit tags -->
        <div class="fg">
            <span class="fg-label">Unit tags</span>
            <div class="tag-wrap">
                <button type="button"
                        class="tag-trigger"
                        [class.has-sel]="selectedUnitTags.selected.length > 0"
                        (click)="toggleUnitTagDropdown(); $event.stopPropagation()">
                    {{ unitTagInputText || 'Select tags...' }}
                </button>
                <div class="tag-dd" [class.open]="unitTagDropdownOpen">
                    <div class="tag-dd-hint">Click to include · click again to exclude · third click removes</div>
                    <div *ngFor="let tag of availableUnitTags; trackBy: trackByTagId"
                         class="tag-dd-item"
                         [class.state-has]="getUnitTagState(tag.tag) === 'has'"
                         [class.state-not]="getUnitTagState(tag.tag) === 'not'"
                         (click)="toggleUnitTag(tag); $event.stopPropagation()">
                        <div class="t-indicator"></div>
                        <span class="t-label">{{ tag.tag }}</span>
                        <span class="t-state-label">
                            {{ getUnitTagState(tag.tag) === 'has' ? 'include' : getUnitTagState(tag.tag) === 'not' ? 'exclude' : '' }}
                        </span>
                    </div>
                    <div *ngIf="availableUnitTags.length === 0" class="tag-dd-empty">
                        No tags available
                    </div>
                </div>
            </div>
        </div>

        <!-- Owner tags -->
        <div class="fg">
            <span class="fg-label">Owner tags</span>
            <div class="tag-wrap">
                <button type="button"
                        class="tag-trigger"
                        [class.has-sel]="selectedOwnerTags.selected.length > 0"
                        (click)="toggleOwnerTagDropdown(); $event.stopPropagation()">
                    {{ ownerTagInputText || 'Select tags...' }}
                </button>
                <div class="tag-dd" [class.open]="ownerTagDropdownOpen">
                    <div class="tag-dd-hint">Click to include · click again to exclude · third click removes</div>
                    <div *ngFor="let tag of availableOwnerTags; trackBy: trackByTagId"
                         class="tag-dd-item"
                         [class.state-has]="getOwnerTagState(tag.tag) === 'has'"
                         [class.state-not]="getOwnerTagState(tag.tag) === 'not'"
                         (click)="toggleOwnerTag(tag); $event.stopPropagation()">
                        <div class="t-indicator"></div>
                        <span class="t-label">{{ tag.tag }}</span>
                        <span class="t-state-label">
                            {{ getOwnerTagState(tag.tag) === 'has' ? 'include' : getOwnerTagState(tag.tag) === 'not' ? 'exclude' : '' }}
                        </span>
                    </div>
                    <div *ngIf="availableOwnerTags.length === 0" class="tag-dd-empty">
                        No tags available
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Backdrop to close dropdowns -->
    <div class="backdrop" *ngIf="unitTagDropdownOpen || ownerTagDropdownOpen || balanceDropdownOpen" (click)="closeAllDropdowns()"></div>

    <!-- Active filter chips -->
    <div class="chips-bar" *ngIf="activeFilterCount > 0">
        <span class="chips-label">Filtered:</span>

        <ng-container *ngFor="let bf of balanceFilters; trackBy: trackByBalanceFilter">
            <span class="chip">
                {{ getBalanceFilterLabel(bf) }}
                <button type="button" class="chip-x" (click)="removeBalanceFilterChip(bf)">&times;</button>
            </span>
        </ng-container>

        <ng-container *ngFor="let tag of selectedUnitTags.selected; trackBy: trackByTagId">
            <span class="chip" [class.neg]="tag.filter === 'not_equals'">
                <button type="button" class="chip-body" (click)="toggleChipMode(tag, 'unit')">
                    <span *ngIf="tag.filter === 'not_equals'" class="chip-mode">NOT</span>
                    {{ tag.tag }}
                </button>
                <button type="button" class="chip-x" (click)="removeUnitTag(tag)">&times;</button>
            </span>
        </ng-container>

        <ng-container *ngFor="let tag of selectedOwnerTags.selected; trackBy: trackByTagId">
            <span class="chip" [class.neg]="tag.filter === 'not_equals'">
                <button type="button" class="chip-body" (click)="toggleChipMode(tag, 'owner')">
                    <span *ngIf="tag.filter === 'not_equals'" class="chip-mode">NOT</span>
                    {{ tag.tag }}
                </button>
                <button type="button" class="chip-x" (click)="removeOwnerTag(tag)">&times;</button>
            </span>
        </ng-container>

        <button type="button" class="chips-clear" (click)="clearAllFilters()">Clear all</button>
    </div>

    <!-- Selection bar -->
    <div class="sel-bar" *ngIf="selection?.selected.length > 0">
        <span class="sel-bar-txt">{{ selection.selected.length }} unit{{ selection.selected.length !== 1 ? 's' : '' }} selected</span>
        <div class="sel-bar-actions">
            <button type="button" class="sel-bar-btn" (click)="selectAllWithBalance()">Select all with balance</button>
            <button type="button" class="sel-bar-btn" (click)="selectAllVisible()">Select all ({{ filteredUnits.length }})</button>
            <button type="button" class="sel-bar-btn muted" (click)="deselectAll()">Deselect all</button>
        </div>
    </div>

    <!-- Loading indicator (background page loading) -->
    <div class="loading-bar-info" *ngIf="isLoadingUnits && units.length > 0">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <span class="loading-bar-text">Loading units... {{ units.length }} of {{ totalRecords }}</span>
    </div>

    <!-- Table — rebuilt on the shared app-table (SD-9782): gives the Columns menu for free
         via its own selectedColumns SelectionModel, and its own MatSort/paginator now own
         sorting/pagination (DATA_ARRAY mode, wired in ngAfterViewInit/recomputeFilteredUnits).
         Search input is app-table's own — [filterPredicate] is neutralized since search
         scoping/filtering stays server-side (getUnitList) via the "Search by field" menu above. -->
    <app-table #appTableRef
               class="units-table"
               [type]="tableType"
               [columnMap]="columnMap"
               [searchControl]="searchControl"
               [filterPredicate]="alwaysMatchFilter"
               [hasFilters]="false"
               [searchPlaceholder]="searchPlaceholderText"
               paginatorStyle="v2"
               [defaultPageSize]="25"
               matSort>

        <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef>
                <div class="ck" [class.on]="isAllSelected()" [class.mid]="isSomeSelected()" (click)="toggleAll()"></div>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <div class="ck" [class.on]="isSelected(row)" (click)="$event.stopPropagation(); toggleRow(row)"></div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="unit">
            <mat-header-cell *matHeaderCellDef mat-sort-header="name">Unit</mat-header-cell>
            <mat-cell *matCellDef="let row" (click)="toggleRow(row)">
                <div class="u-title" [innerHTML]="highlight(row.name)"></div>
                <div class="u-match" *ngIf="getMatchSource(row) as matchSrc">
                    <span [innerHTML]="highlight(matchSrc)"></span>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="address">
            <mat-header-cell *matHeaderCellDef>Address</mat-header-cell>
            <mat-cell *matCellDef="let row" (click)="toggleRow(row)">
                <div class="u-addr-line" [innerHTML]="highlight(row.address?.line1 || '')"></div>
                <div class="u-addr-city">
                    <span [innerHTML]="highlight(row.address?.city || '')"></span><ng-container *ngIf="row.address?.region">, <span [innerHTML]="highlight(row.address.region)"></span></ng-container><ng-container *ngIf="row.address?.postalCode">&nbsp;<span [innerHTML]="highlight(row.address.postalCode)"></span></ng-container>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tags">
            <mat-header-cell *matHeaderCellDef>Tags</mat-header-cell>
            <mat-cell *matCellDef="let row" (click)="toggleRow(row)">
                <div class="u-tags" *ngIf="row.tags?.length > 0">
                    <span *ngFor="let tag of row.tags; trackBy: trackByTagId"
                          class="u-tag"
                          [ngClass]="tagColorClass(tag)">
                        {{ tag.tag }}
                    </span>
                </div>
                <span *ngIf="!row.tags?.length" class="no-tags">&mdash;</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="balance">
            <mat-header-cell *matHeaderCellDef mat-sort-header="balance" class="r">Balance</mat-header-cell>
            <mat-cell *matCellDef="let row" class="r" (click)="toggleRow(row)">
                <span class="u-bal" [class.zero]="row.balance === 0">
                    {{ row.balance | legfiCurrency:'USD':'symbol':'.2' }}
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="pastDueBalance">
            <mat-header-cell *matHeaderCellDef mat-sort-header="pastDueBalance" class="r">Past Due</mat-header-cell>
            <mat-cell *matCellDef="let row" class="r" (click)="toggleRow(row)">
                <span class="u-bal" [class.zero]="row.pastDueBalance === 0">
                    {{ row.pastDueBalance | legfiCurrency:'USD':'symbol':'.2' }}
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="owners">
            <mat-header-cell *matHeaderCellDef>Owners</mat-header-cell>
            <mat-cell *matCellDef="let row" (click)="toggleRow(row)">
                <div class="u-owners">
                    <span *ngFor="let owner of row.owners; trackBy: trackByOwnerId"
                          class="u-owner"
                          [innerHTML]="highlight(owner.name)">
                    </span>
                </div>
                <span *ngIf="!row.owners?.length" class="no-tags">No owners</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mobile">
            <mat-header-cell *matHeaderCellDef>Unit</mat-header-cell>
            <mat-cell *matCellDef="let row" [emptyCell]="!row.name" (click)="toggleRow(row)">
                <div class="u-title" [innerHTML]="highlight(row.name)"></div>
                <div class="u-addr-line" *ngIf="row.address?.line1">{{ row.address.line1 }}</div>
                <span class="u-bal" [class.zero]="row.balance === 0">
                    {{ row.balance | legfiCurrency:'USD':'symbol':'.2' }}
                </span>
            </mat-cell>
        </ng-container>

        <app-empty-state>
            <span emptyStateTitle>No units match</span>
        </app-empty-state>
    </app-table>
</div>
